export default __webpack_public_path__ + "static/sdk-phone-med-33e680560abfa325f0a6c73a8ecd4bde.mp4";